import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { Subject, takeUntil } from 'rxjs';

import { FeatureRequestApiService, FeatureRequestDto } from '@shure/cloud/shared/feature-request/data-access';
import { AnalyticsEvents, AnalyticsService } from '@shure/cloud/shared/utils/analytics';
import { PrismDialogRef, PrismSnackbarService } from '@shure/prism-angular-components';

@Component({
	selector: 'sh-feature-request-main',
	templateUrl: './feature-request-main.component.html',
	styleUrls: ['./feature-request-main.component.scss']
})
export class FeatureRequestMainComponent implements OnInit, OnDestroy {
	public showSnackbar = signal(false);
	public formGroup: FormGroup = new FormGroup({});
	public formData = [
		{
			name: 'title',
			validators: []
		},
		{
			name: 'description',
			validators: [Validators.required]
		}
	];
	private readonly destroy$ = new Subject<void>();
	public isFormChanged = true;

	constructor(
		private formBuilder: FormBuilder,
		private dialogRef: PrismDialogRef<FeatureRequestMainComponent>,
		private analyticsService: AnalyticsService,
		public translocoService: TranslocoService,
		public featureRequestService: FeatureRequestApiService,
		private snackBarService: PrismSnackbarService
	) {}

	public ngOnInit(): void {
		this.formGroup = this.formBuilder.group({});
		this.formData?.forEach((formControlDetail) => {
			this.formGroup.addControl(formControlDetail.name, new FormControl('', formControlDetail.validators));
		});
	}

	public ngOnDestroy(): void {
		this.destroy$.complete();
	}

	public doAction(): void {
		if (this.formGroup.valid) {
			/* eslint-disable @typescript-eslint/naming-convention */
			this.analyticsService.analyticDataCollector(AnalyticsEvents.HelpRequested, { request_type: 'feature' });
		}

		if (this.formGroup.valid) {
			const requestData = this.formGroup.value;
			this.analyticsService.analyticDataCollector(AnalyticsEvents.HelpRequested, { request_type: 'feature' });
			this.submitFeatureRequest(requestData); // Call API
		}
	}

	public closeDialog(): void {
		this.dialogRef.close();
	}

	/**
	 *	This method is called to submit the feature request using the response
	 * 	@param featureRequestData - object of type FeatureRequestDto
	 */
	public submitFeatureRequest(featureRequestData: FeatureRequestDto): void {
		this.closeDialog();
		this.featureRequestService
			.submitFeatureRequest$Response({ body: featureRequestData })
			?.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: (featureRequestResponse) => {
					const featureRequestResponseBody = featureRequestResponse?.body;
					this.snackBarService.open({
						message: this.translocoService.translate(
							'cloud.shared.header.' + featureRequestResponseBody?.body?.messageKey
						),
						actionText: this.translocoService.translate('common.buttons.ok')
					});
				},
				error: (error) => {
					const errorResponse = error.error;
					this.snackBarService.open({
						message: this.translocoService.translate(
							errorResponse.i18nKey
								? 'cloud.shared.error-labels.' + errorResponse.i18nKey
								: errorResponse.message
						),
						actionText: this.translocoService.translate('common.buttons.ok')
					});
				}
			});
	}
}
